import { baseApi } from '@shared/api/baseApi';
export type IdentityProvider = 'GOOGLE' | 'TELEGRAM';
export interface AccountDto {
  id: string;
  displayName: string;
  firstName: string | null;
  telegramId: string | null;
  identities: { provider: IdentityProvider; connected: boolean; label: string | null }[];
  browserSession: boolean;
}
export const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccount: builder.query<AccountDto, void>({ query: () => '/account', transformResponse: (response: { account: AccountDto }) => response.account, providesTags: ['Account'] }),
    updateAccount: builder.mutation<{ ok: boolean }, { displayName: string }>({ query: (body) => ({ url: '/account', method: 'PATCH', body }), invalidatesTags: ['Account', 'User'] }),
    getAuthProviders: builder.query<{ providers: { provider: IdentityProvider; available: boolean }[] }, void>({ query: () => '/auth/providers' }),
    startSignIn: builder.mutation<{ url: string }, { provider: IdentityProvider; intent: 'login' | 'link' }>({ query: ({ provider, intent }) => ({ url: `/auth/${provider.toLowerCase()}/start`, method: 'POST', body: { intent } }) }),
    signOut: builder.mutation<{ ok: boolean }, void>({ query: () => ({ url: '/auth/logout', method: 'POST' }) }),
  }),
});
export const { useGetAccountQuery, useUpdateAccountMutation, useGetAuthProvidersQuery, useStartSignInMutation, useSignOutMutation } = accountApi;

export function signInError(code: string | null): string | null {
  if (!code) return null;
  const messages: Record<string, string> = {
    IDENTITY_ALREADY_LINKED: 'That sign-in belongs to another YeneShop account. Sign in to that account to keep its balance and purchases. Accounts are not merged automatically.',
    PROVIDER_ALREADY_LINKED: 'Your account is already connected to a different identity from this provider.',
    LINK_SESSION_CHANGED: 'Your session changed. Sign in and connect the account again.',
    INVALID_SIGN_IN_STATE: 'This sign-in expired or was already used. Please try again.',
    SIGN_IN_CANCELLED: 'Sign-in was cancelled. You can try again when ready.',
    PROVIDER_NOT_CONFIGURED: 'This sign-in provider is not configured yet.',
    USER_BANNED: 'This account is suspended. Contact YeneShop support for help.',
  };
  return messages[code] ?? 'We could not complete sign-in. Please try again.';
}
